import {
  FETCH_RUBRICS_FULFILLED,
  FETCH_RUBRICS_PENDING,
  FETCH_RUBRICS_REJECTED,
  RubricsTypes,
  RubricsState,
} from './types';

const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};

export const reducer = (
  state: RubricsState = initialState,
  action: RubricsTypes,
) => {
  switch (action.type) {
    case FETCH_RUBRICS_PENDING: {
      return {
        ...state,
        fetched: false,
        fetching: true,
      };
    }
    case FETCH_RUBRICS_FULFILLED: {
      const { data, nbResult } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data[0]],
        nbResult: nbResult,
      };
    }
    case FETCH_RUBRICS_REJECTED: {
      let error = action.payload;
      switch (error?.response?.status) {
        case 404:
          error = {
            title: error?.response?.data?.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: error,
        items: [],
        nbResult: 0,
      };
    }
    default:
      return state;
  }
};
export default reducer;
